import React from "react";
import { useTranslation } from "react-i18next";

import { alpha } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import ObjectsDrawer from "./ObjectsDrawer";

const useStyles = makeStyles((theme) => ({
    AccordionRoot: {
        // border: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        border: "none",
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
    AccordionSummaryRoot: {
        backgroundColor: alpha(theme.palette.primary.main, 0.0675),
        // borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.125)}`,
        
        marginBottom: -1,
        minHeight: "32px!important",
        "&$expanded": {
            minHeight: 32,
        },
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        margin: theme.spacing(0, 0),
    },
    AccordionSummaryTitle: {
        fontSize: "clamp(12px, 1vw, 1rem)",
        fontWeight: theme.typography.fontWeightMedium,
    },
    AccordionSummaryExpandIcon: {
        transform: "rotate(0deg)!important",
        marginRight: "0!important",
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2),
    },
    card: {
        height: "100%",
    },
    cardHeaderRoot: {
        backgroundColor: alpha(theme.palette.primary.main, 0.00675),
        padding: theme.spacing(1, 1, 0, 2),
    },
    cardContent: {
        padding: theme.spacing(0, 1, 2, 2),
    },
    cardHeaderTitle: {
        fontSize: "clamp(12px, 1vw, 1rem)",
        fontWeight: theme.typography.fontWeightMedium,
    },
}));

const ObjectsAccordion = ({ id_obiektu, cechyobiektu, onExpand }) => {
    // eslint-disable-next-line
    const { t } = useTranslation();
    // eslint-disable-next-line
    const classes = useStyles();
    // eslint-disable-next-line
    const [expanded, setExpanded] = React.useState("panel1");

    // eslint-disable-next-line
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div style={{ width: "100%" }}>
            <ObjectsDrawer id_obiektu={id_obiektu} cechyobiektu={cechyobiektu} />
        </div>
    );
};

export default ObjectsAccordion;
